import { render, staticRenderFns } from "./RegistrationView.vue?vue&type=template&id=3a6025ee&scoped=true&"
import script from "./RegistrationView.vue?vue&type=script&lang=js&"
export * from "./RegistrationView.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationView.vue?vue&type=style&index=0&id=3a6025ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6025ee",
  null
  
)

export default component.exports